import React, { useState } from 'react'

import { IconButton, InputBase, makeStyles, Paper } from '@material-ui/core'
import PropTypes from 'prop-types'

import { SearchIcon } from 'components/icons/personalizedIcons'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 410,
    height: 48,
    border: '2px solid #7A7A7A',
    borderRadius: 8,
    marginTop: 15,
    boxShadow: 'none',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontFamily: 'Red Hat Display Regular',
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}))

const SearchBox = ({ placeholder, onSubmit }) => {
  const classes = useStyles()
  const [searchText, setSearchText] = useState('')

  return (
    <Paper className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        onKeyUp={(e) => {
          e.preventDefault()
          if (e.key === 'Enter' && searchText.length > 0) {
            onSubmit(searchText.trim())
          } else if (searchText.length === 0) {
            onSubmit('')
          }
        }}
        onChange={(e) => {
          setSearchText(e.target.value.trimStart())
        }}
        value={searchText}
      />
      <IconButton
        onClick={(e) => {
          e.preventDefault()
          if (searchText.length > 0) {
            onSubmit(searchText.trim())
          }
        }}
        className={classes.iconButton}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  )
}
SearchBox.propTypes = {
  placeholder: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
}

SearchBox.defaultProps = {
  placeholder: '¿Qué estás buscando?',
}

export default SearchBox
